import { useNavigate } from "react-router-dom";

const BackButton = () => {
  const navigate = useNavigate();
  return (
    <button className="mt-4 btn btn-link" onClick={() => navigate(-1)}>
      <i className="bi bi-arrow-left me-2"></i> Back
    </button>
  );
};

export default BackButton;
